export default __webpack_public_path__ + "static/media/Q_Quatro.d1e0d0d1.svg";